import React from 'react';
import AboutCarousel from './AboutCarousel';

const About = () => {
  return (
    <>
      <div className="flex flex-col justify-center items-center pt-10">
          {/* Added About Us Title */}
          <div className="text-center mb-8 md:mb-8 ">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mt-4">About Us</h1>
            <div className="w-24 h-1 bg-blue-500 mx-auto"></div>
          </div>

        <div className="max-w-5xl w-full">
          <p className="home-intro">
            The Xtal Ball entity has been created for development and manufacturing of extraordinary Frequency Control and Timing products combining very high precision and accuracy with small sizes and extremely low power consumption.
          </p>

          <div className="hello-article">
            <h4 className="hello-article__title">
              Precision matters{" "}
              <span></span>
            </h4>

            <p className="mx-4 text-base indent-8 py-8 first-letter:font-['Raleway-SemiBold'] first-letter:text-2xl first-letter:text-[#color-secondary-2-2]">
              <span className="font-['Raleway-SemiBold']">
                Production facilities of Xtal Ball allow large scale manufacturing the crystal resonators, OCXOs and Timing modules from the crystal blank stage. Usage of automatic test lines incorporating in unique information system providing full transparency of the products evolution from design documentation through all manufacting procedures till delivery to the customer.
              </span>
            </p>

            <AboutCarousel />

            <p className="mx-4 text-base indent-8 py-8 first-letter:font-['Raleway-SemiBold'] first-letter:text-2xl first-letter:text-[#color-secondary-2-2]">
              <span className="font-['Raleway-SemiBold']">
                Basing on the LP OCXOs operating at 8.192 MHz or 16.384 MHz
                frequency these clocks ensure very high precision of 1 s time
                intervals at very low power consumption and small sizes. Owing to
                the very attractive combination of properties these clocks are now
                very demanded part of different modern equipment with battery
                supply, for instance, of the underwater geological exploration
                equipment providing its long service-free period at high precision
                of the geological data.
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;